export default [
  {
    path: "/order/list/:type?",
    name: "MyOrder",
    meta: {
      title: "我的订单",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/MyOrder")
  },
   {
    path: "/agent/order/list/:type?",
    name: "MyAgentOrder",
    meta: {
      title: "我的代理订单",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/agent/MyOrder")
  },
  {
    path: "/order/logistics/:id",
    name: "Logistics",
    meta: {
      title: "物流信息",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/Logistics")
  },
   {
    path: "/agent/order/logistics/:id",
    name: "AgentLogistics",
    meta: {
      title: "代理物流信息",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/agent/Logistics")
  },
  {
    path: "/agent/order/detail/:id",
    name: "agentOrderDetails",
    meta: {
      title: "代理订单详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/agent/OrderDetails")
  },
  {
    path: "/order/detail/:id",
    name: "OrderDetails",
    meta: {
      title: "订单详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/OrderDetails")
  },
  {
    path: "/order/submit/:id",
    name: "OrderSubmission",
    meta: {
      title: "提交订单",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/OrderSubmission")
  },
  {
    path: "/agent/order/submit/:id",
    name: "agentOrderSubmission",
    meta: {
      title: "提交代理订单",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/agent/OrderSubmission")
  },
  {
    path: "/order/status/:id/:status",
    name: "PaymentStatus",
    meta: {
      title: "支付状态",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/PaymentStatus")
  },
   {
    path: "/agent/order/status/:id/:status",
    name: "agentPaymentStatus",
    meta: {
      title: "代理支付状态",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/agent/PaymentStatus")
  },
  {
    path: "/order/refund/:id",
    name: "GoodsReturn",
    meta: {
      title: "申请退款",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/GoodsReturn.vue")
  },
   {
    path: "/agent/order/refund/:id",
    name: "agentRefund",
    meta: {
      title: "代理申请退款",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/agent/refund.vue")
  },
  {
    path: "/agent/order/service_list/:order_id",
    name: "OrderServiceList",
    meta: {
      title: "选择售后类型",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/agent/OrderServiceList.vue")
  },
  {
    path: "/order/refund_list",
    name: "ReturnList",
    meta: {
      title: "退货列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/ReturnList.vue")
  },
  {
    path: "/integralorder/status/:id/:status",
    name: "integralPaymentStatus",
    meta: {
      title: "积分支付状态",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/integral/integralPaymentStatus.vue")
  },
  {
    path: "/order/status_agent/:id",
    name: "PaymentStatusAgent",
    meta: {
      title: "代理申请支付状态",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/PaymentStatusAgent")
  },
  //10.21新加代理续费状态
  {
    path: "/order/status_renewal/:id",
    name: "AgencyRenewalStatus",
    meta: {
      title: "代理续费支付状态",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/AgencyRenewalStatus")
  },
  {
    path: "/integralorder/refund/:id",
    name: "integralGoodsReturn",
    meta: {
      title: "积分申请退货",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/integral/integralGoodsReturn")
  },
  {
    path: "/integral/OrderSubmit/:id",
    name: "IntegralOrderSubmission",
    meta: {
      title: "积分订单提交",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/integral/IntegralOrderSubmission.vue")
  },
  {
    path: "/integralOrder/detail/:id",
    name: "integralOrderDetails",
    meta: {
      title: "积分订单详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/integral/integralOrderDetail.vue")
  }, 
  {
    path: "/integralorder/refund_list",
    name: "integralReturnList",
    meta: {
      title: "积分退货列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/integral/integralReturnList.vue")
  },
  {
    path: "/order/logistics_info/:order_id",
    name: "FillLogisticsInfo",
    meta: {
      title: "填写退货物流",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/FillLogisticsInfo.vue")
  },
  {
    path: "/order/presell_order_list",
    name: "PresellOrderList",
    meta: {
      title: "预售订单列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/PresellOrderList.vue")
  },
  {
    path: "/order/service_list/:order_id",
    name: "OrderServiceList",
    meta: {
      title: "选择售后类型",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/OrderServiceList.vue")
  },
  {
    path: "/order/after_sale/:id",
    name: "GoodsAfterSale",
    meta: {
      title: "申请售后",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/GoodsAfterSale.vue")
  },
  {
    path: "/order/status_displace/:id",
    name: "DisplaceStatus",
    meta: {
      title: "置换订单支付状态",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/DisplaceStatus")
  },
  {
    path: "/order/status_offline/:id",
    name: "OfflineStatus",
    meta: {
      title: "进货订单支付状态",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/OfflineStatus")
  },
];
